<template>
    <v-snackbar
            v-model="active"
            :multi-line="mode === 'multi-line'"
            :right="true"
            :timeout="timeout"
            :top="true"
            :vertical="mode === 'vertical'"
            v-on:input="changeActive()"
            color="secondary"
            class="text--primary"
    >
        {{ text }}
        <v-btn
                color="pink"
                flat
                @click="active = false"
        >
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        data () {
            return {
                active: false,
                y: 'top',
                x: null,
                mode: '',
                timeout: 6000,
            }
        },
        computed: {
            text: function () {
                return this.$store.getters.getSnackBarText
            },
            snackbar: function () {
                return this.$store.getters.getSnackBarActive
            }
        },
        watch: {
            snackbar: function (val) {
                this.active = val;
            },
        },
        methods: {
            changeActive () {
                this.$store.dispatch('activeSnack')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/SnackBarComponent.vue